import { styled } from '@mui/material/styles';

export const UnreadBadge = styled('div')(({ theme }) => ({
  minWidth: 10,
  minHeight: 10,
  borderRadius: 5,
  backgroundColor: theme.palette.notification.main,
  borderStyle: 'solid',
  borderWidth: 0,
  '&.read': {
    backgroundColor: theme.palette.background.paper,
    borderWidth: 1,
    borderColor: theme.palette.grey[500]
  }
}));
